import colorLight from './light';

const colorDark = {
  ...colorLight,
};

export default colorDark;
